import { stringToColor } from '../../../utils/AvatarUtils';

export const WORKFLOW_OPERATOR_AGENT_NAME = 'Workflow Operator';

export const GHOST_CURSOR_ENTRY_MS = 900;
export const GHOST_CURSOR_ACTING_MS = 2500;

export function isGhostCursorChatInProgress(chatStatus) {
  return chatStatus === 'submitted' || chatStatus === 'streaming';
}

export function getWorkflowOperatorAvatarColor(name = WORKFLOW_OPERATOR_AGENT_NAME) {
  return stringToColor(name);
}

/** Theme-aware styles for the floating name tag under the ghost cursor. */
export function getGhostCursorNameTagStyle(avatarColor, theme) {
  const isDark = theme.palette.mode === 'dark';

  if (isDark) {
    return {
      background: theme.palette.background.paper,
      color: theme.palette.text.primary,
      border: `1px solid ${avatarColor}`,
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.45)',
      statusColor: theme.palette.text.secondary,
    };
  }

  return {
    background: avatarColor,
    color: '#ffffff',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.22)',
    statusColor: 'rgba(255, 255, 255, 0.82)',
  };
}
